import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { Order } from '../../api/models/order';
import { LoadOrders } from './orders.actions';
import { OrdersService } from '../../api/services/orders.service';

export class OrdersStateModel {
  orders: Order[];
  canLoadMore: boolean;
}

@State<OrdersStateModel>({
  name: 'orders',
  defaults: {
    orders: [],
    canLoadMore: false
  }
})
@Injectable()
export class OrdersState {
  private ordersService = inject(OrdersService);

  @Selector()
  static orders(state: OrdersStateModel): Order[] {
    return state.orders;
  }

  @Selector()
  static canLoadMore(state: OrdersStateModel): boolean {
    return state.canLoadMore;
  }

  @Action(LoadOrders)
  private loadOrders(ctx: StateContext<OrdersStateModel>, action: LoadOrders) {
    return this.ordersService
      .apiOrderOrdersGet({ pageIndex: action.pageIndex, itemsToTake: action.itemsToTake })
      .subscribe({
        next: (orders: Order[]) => {
          const orderIds = ctx.getState().orders.map((o) => o.id);
          return ctx.patchState({
            orders: ctx.getState().orders.concat(orders.filter((o) => !orderIds.includes(o.id))),
            canLoadMore: action.itemsToTake === orders.length
          });
        },
        error: () => {
          return ctx.patchState({ canLoadMore: true });
        }
      });
  }
}
